export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// For phone numbers (assuming Ethiopian format)
export const PHONE_REGEX = /^[79]\d{8}$/;

// For names (allowing Amharic characters)
export const NAME_REGEX = /^[\u1200-\u137F\s]{2,1000}$/;

// Invalid username. Your username can only include Amharic letters, spaces, underscores, and numbers. It must be between 2 and 20 characters in length.
export const USERNAME_REGEX = /^[\u1200-\u137F\s_0-9]{2,20}$/;

export const PASSWORD_REGEX = /^[\u1200-\u137Fa-zA-Z_]{8,20}$/;

export const GENDER_REGEX = /^(ወንድ|ሴት)$/i;

export const STATUS_REGEX = /^(ንቁ|ታግዷል)$/i;

export const CHURCH_CATEGORY_REGEX = /^(ገዳም|አጥቢያ|ካቴድራል)$/i;

export const DESCRIPTION_REGEX = /^.{2,1000}$/s;

export const DECIMAL_REGEX = /^\d*\.?\d*$/;

export const CURRENCY_REGEX = /^(ETB|USD)$/i;
